export default __webpack_public_path__ + "static/media/church-1.844200dd.jpg";